import { render, staticRenderFns } from "./h5New.vue?vue&type=template&id=d9fb83ea&scoped=true&"
import script from "./h5New.vue?vue&type=script&lang=js&"
export * from "./h5New.vue?vue&type=script&lang=js&"
import style0 from "./h5New.vue?vue&type=style&index=0&id=d9fb83ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fb83ea",
  null
  
)

export default component.exports